module.exports = __webpack_public_path__ + "modelace-postavy-liposukce_15_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/modelace-postavy-liposukce_15_before.jpg
// module id = 1094
// module chunks = 0